/* Bunker Boys — Father's Day countdown.
   Enhances any [data-bb-countdown] element with a live days/hrs/min timer.
   Self-guarding: safe to include from multiple sections. No dependencies.
   Degrades gracefully: timer stays hidden until JS confirms a valid future
   deadline, so the static "order by" copy is what shows without JS. */
(function () {
  if (window.__bbFdCountdownInit) return;
  window.__bbFdCountdownInit = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var nodes = document.querySelectorAll('[data-bb-countdown]');
    var now = Date.now();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var deadline = Date.parse(el.getAttribute('data-bb-countdown'));
      if (isNaN(deadline)) continue;
      var timer = el.querySelector('[data-bb-countdown-timer]');
      var expired = el.querySelector('[data-bb-countdown-expired]');
      var diff = deadline - now;
      if (diff <= 0) {
        if (timer) timer.hidden = true;
        if (expired) expired.hidden = false;
        el.setAttribute('data-bb-countdown-state', 'expired');
        continue;
      }
      var days = Math.floor(diff / 86400000);
      var hrs = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var d = el.querySelector('[data-cd-days]');
      var h = el.querySelector('[data-cd-hours]');
      var m = el.querySelector('[data-cd-mins]');
      if (d) d.textContent = days;
      if (h) h.textContent = pad(hrs);
      if (m) m.textContent = pad(mins);
      if (timer) timer.hidden = false;
      el.setAttribute('data-bb-countdown-state', 'live');
    }
  }

  function start() { tick(); setInterval(tick, 30000); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
